import { render, staticRenderFns } from "./monthFixRecord.vue?vue&type=template&id=978e3154&"
import script from "./monthFixRecord.vue?vue&type=script&lang=js&"
export * from "./monthFixRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports